'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 15px;\n'], ['\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 15px;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Button = require('../../Button/Button');

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Components


var Container = _styledComponents2.default.div(_templateObject);

var NotificationButtons = function NotificationButtons(_ref) {
  var primary = _ref.primary,
      secondary = _ref.secondary;
  return !primary && !secondary ? null : _react2.default.createElement(Container, null, _react2.default.createElement('div', null, secondary && _react2.default.createElement(_Button2.default, {
    theme: 'grey',
    onClick: secondary.onClick,
    size: 'small'
  }, secondary.label)), _react2.default.createElement('div', null, primary && _react2.default.createElement(_Button2.default, {
    theme: 'red',
    onClick: primary.onClick,
    size: 'small'
  }, primary.label)));
};

NotificationButtons.propTypes = {
  primary: _propTypes2.default.object,
  secondary: _propTypes2.default.object
};
exports.default = NotificationButtons;